// extracted by mini-css-extract-plugin
export default {"root":"PageMotherD_root__paYAg","inner":"PageMotherD_inner__HCeMZ","content":"PageMotherD_content__-Vdww","back":"PageMotherD_back__lX4mC"};